import lazyWithRetry from './lazyWithRetry.js';
// HomeLanding NO se lazy-carga: es la ruta de aterrizaje principal y debe
// renderizar en el primer frame para que el hero (LCP) pinte sin waterfall.
import HomeLanding from '../pages/HomeLanding.jsx';

// ── Páginas públicas ──────────────────────────────────────────────
const LazyResetPassword           = lazyWithRetry(() => import('../pages/ResetPassword.jsx'));
const LazyTerminosYCondiciones    = lazyWithRetry(() => import('../pages/TerminosYCondiciones.jsx'));
const LazyPoliticaDePrivacidad    = lazyWithRetry(() => import('../pages/PoliticaDePrivacidad.jsx'));
const LazyVerificarEmail          = lazyWithRetry(() => import('../pages/VerificarEmail.jsx'));
const LazyReservarTurno           = lazyWithRetry(() => import('../pages/ReservarTurno.jsx'));
const LazySeguimientoReserva      = lazyWithRetry(() => import('../pages/SeguimientoReserva.jsx'));
const LazyPagoExitoso             = lazyWithRetry(() => import('../pages/PagoExitoso.jsx'));
const LazyPagoFallido             = lazyWithRetry(() => import('../pages/PagoFallido.jsx'));
const LazyPagoPendiente           = lazyWithRetry(() => import('../pages/PagoPendiente.jsx'));
const LazyCuentaVinculadaConExito = lazyWithRetry(() => import('../pages/CuentaVinculadaConExito.jsx'));
const LazyErrorVinculacion        = lazyWithRetry(() => import('../pages/ErrorVinculacion.jsx'));
const LazyReservaExitosa          = lazyWithRetry(() => import('../pages/ReservaExitosa.jsx'));
const LazyReservaFallida          = lazyWithRetry(() => import('../pages/ReservaFallida.jsx'));
const LazyReservaPendiente        = lazyWithRetry(() => import('../pages/ReservaPendiente.jsx'));
const LazyActivarCuenta           = lazyWithRetry(() => import('../pages/ActivarCuenta.jsx'));
const LazyBienvenidaPremium        = lazyWithRetry(() => import('../pages/BienvenidaPremium.jsx'));

// ── Páginas protegidas (requieren login) ──────────────────────────
const LazyDashboard               = lazyWithRetry(() => import('../pages/Dashboard.jsx'));
const LazyProfileForm             = lazyWithRetry(() => import('../pages/ProfileForm.jsx'));
const LazyProfileView             = lazyWithRetry(() => import('../components/ProfileView.jsx'));
const LazyVistaHorarios           = lazyWithRetry(() => import('../pages/VistaHorarios.jsx'));
const LazyAgendaConFecha          = lazyWithRetry(() => import('../pages/AgendaConFecha.jsx'));
const LazyHistorialCitas          = lazyWithRetry(() => import('../pages/HistorialCitas.jsx'));
const LazyClientes                = lazyWithRetry(() => import('../pages/Clientes.jsx'));
const LazyServicios               = lazyWithRetry(() => import('../pages/Servicios.jsx'));
const LazyFechasDeshabilitadas    = lazyWithRetry(() => import('../components/FechasDeshabilitadas.jsx'));
const LazyEstadisticasClientes    = lazyWithRetry(() => import('../pages/EstadisticasClientes.jsx'));
const LazyHistorialDePagos        = lazyWithRetry(() => import('../pages/HistorialDePagos.jsx'));
const LazyManageSubscriptionPage  = lazyWithRetry(() => import('../pages/ManageSubscriptionPage.jsx'));
const LazyDetallesReserva         = lazyWithRetry(() => import('../pages/DetallesReserva.jsx'));
const LazySubscriptionPage        = lazyWithRetry(() => import('../components/SubscriptionPage.jsx'));
const LazyIntegrationsPage        = lazyWithRetry(() => import('../pages/IntegrationsPage.jsx'));
const LazyReferidos               = lazyWithRetry(() => import('../pages/Referidos.jsx'));
const LazyMisTickets              = lazyWithRetry(() => import('../pages/MisTickets.jsx'));
const LazyClientProfileForm       = lazyWithRetry(() => import('../pages/ClientProfileForm.jsx'));
const LazyMisTurnosCliente        = lazyWithRetry(() => import('../pages/MisTurnosCliente.jsx'));
const LazyDashboardCliente        = lazyWithRetry(() => import('../pages/DashboardCliente.jsx'));
const LazyPerfilCliente           = lazyWithRetry(() => import('../pages/PerfilCliente.jsx'));

// ── Páginas de administrador ──────────────────────────────────────
const LazyAdminDashboard          = lazyWithRetry(() => import('../pages/AdminDashboard.jsx'));
const LazyAdminEstadisticas       = lazyWithRetry(() => import('../pages/AdminEstadisticas.jsx'));
const LazyAdminCitas              = lazyWithRetry(() => import('../pages/AdminCitas.jsx'));
const LazyAdminFinancialReports   = lazyWithRetry(() => import('../pages/AdminFinancialReports.jsx'));
const LazyAdminActivityFeed       = lazyWithRetry(() => import('../pages/AdminActivityFeed.jsx'));
const LazyAdminUsuarios           = lazyWithRetry(() => import('../pages/AdminUsuarios.jsx'));
const LazyAdminUsuarioDetalle     = lazyWithRetry(() => import('../pages/AdminUsuarioDetalle.jsx'));
const LazyAdminSuscripciones      = lazyWithRetry(() => import('../pages/AdminSuscripciones.jsx'));
const LazyAdminComunicaciones     = lazyWithRetry(() => import('../pages/AdminComunicaciones.jsx'));
const LazyAdminAnnouncements      = lazyWithRetry(() => import('../pages/AdminAnnouncements.jsx'));
const LazyAdminReferralWithdrawals = lazyWithRetry(() => import('../pages/AdminReferralWithdrawals.jsx'));
const LazyAdminLoginLogs          = lazyWithRetry(() => import('../pages/AdminLoginLogs.jsx'));
const LazyAdminTickets            = lazyWithRetry(() => import('../pages/AdminTickets.jsx'));
const LazyAdminPagosMonitor       = lazyWithRetry(() => import('../pages/AdminPagosMonitor.jsx'));
const LazyAdminRegistroIncompleto = lazyWithRetry(() => import('../pages/AdminRegistroIncompleto.jsx'));

// ── Especiales (overlay o catch-all, no son entradas de array) ────
const LazyNotFoundPage            = lazyWithRetry(() => import('../pages/NotFoundPage.jsx'));
const LazyImpersonationBanner     = lazyWithRetry(() => import('../components/ImpersonationBanner.jsx'));

// ── Arrays de configuración de rutas ─────────────────────────────

export const publicRoutes = [
  { path: '/',                            component: HomeLanding },
  { path: '/reset-password',              component: LazyResetPassword },
  { path: '/terminos',                    component: LazyTerminosYCondiciones },
  { path: '/privacidad',                  component: LazyPoliticaDePrivacidad },
  { path: '/verificar-email',             component: LazyVerificarEmail },
  { path: '/activar',                     component: LazyActivarCuenta },
  { path: '/bienvenida-premium',          component: LazyBienvenidaPremium },
  { path: '/p/:slug',                     component: LazyReservarTurno },
  { path: '/reserva/:id',                 component: LazySeguimientoReserva },
  { path: '/pago-exitoso',                component: LazyPagoExitoso },
  { path: '/pago-fallido',                component: LazyPagoFallido },
  { path: '/pago-pendiente',              component: LazyPagoPendiente },
  { path: '/cuenta-vinculada-con-exito',  component: LazyCuentaVinculadaConExito },
  { path: '/error-vinculacion',           component: LazyErrorVinculacion },
  { path: '/reserva-exitosa',             component: LazyReservaExitosa },
  { path: '/reserva-fallida',             component: LazyReservaFallida },
  { path: '/reserva-pendiente',           component: LazyReservaPendiente },
];

export const protectedRoutes = [
  { path: '/dashboard',                   component: LazyDashboard },
  { path: '/profile',                     component: LazyProfileForm },
  { path: '/perfil',                      component: LazyProfileView },
  { path: '/ver-horarios',               component: LazyVistaHorarios },
  { path: '/agenda-fechas',              component: LazyAgendaConFecha },
  { path: '/historial',                   component: LazyHistorialCitas },
  { path: '/clientes',                    component: LazyClientes },
  { path: '/servicios',                   component: LazyServicios },
  { path: '/fechas-deshabilitadas',       component: LazyFechasDeshabilitadas },
  { path: '/estadisticas',               component: LazyEstadisticasClientes },
  { path: '/historial-pagos',            component: LazyHistorialDePagos },
  { path: '/manage-subscription',         component: LazyManageSubscriptionPage },
  { path: '/reservas/:id',               component: LazyDetallesReserva },
  { path: '/subscribe',                   component: LazySubscriptionPage },
  { path: '/integrar',                    component: LazyIntegrationsPage },
  { path: '/referidos',                   component: LazyReferidos },
  { path: '/mis-tickets',                 component: LazyMisTickets },
  { path: '/client-profile',              component: LazyClientProfileForm },
  { path: '/mis-turnos',                  component: LazyMisTurnosCliente },
  { path: '/turnos-con-otros',            component: LazyMisTurnosCliente },
  { path: '/dashboard-cliente',           component: LazyDashboardCliente },
  { path: '/perfil-cliente',              component: LazyPerfilCliente },
];

export const adminRoutes = [
  { path: '/admin/dashboard',             component: LazyAdminDashboard },
  { path: '/admin/estadisticas',          component: LazyAdminEstadisticas },
  { path: '/admin/citas',                 component: LazyAdminCitas },
  { path: '/admin/reportes-financieros',  component: LazyAdminFinancialReports },
  { path: '/admin/activity',             component: LazyAdminActivityFeed },
  { path: '/admin/usuarios',              component: LazyAdminUsuarios },
  { path: '/admin/usuarios/:uid',         component: LazyAdminUsuarioDetalle },
  { path: '/admin/suscripciones',         component: LazyAdminSuscripciones },
  { path: '/admin/comunicaciones',        component: LazyAdminComunicaciones },
  { path: '/admin/announcements',         component: LazyAdminAnnouncements },
  { path: '/admin/referidos-retiros',     component: LazyAdminReferralWithdrawals },
  { path: '/admin/login-logs',            component: LazyAdminLoginLogs },
  { path: '/admin/tickets',               component: LazyAdminTickets },
  { path: '/admin/pagos-monitor',         component: LazyAdminPagosMonitor },
  { path: '/admin/registro-incompleto',   component: LazyAdminRegistroIncompleto },
];

export { LazyNotFoundPage, LazyImpersonationBanner };
